<template>
  <div class="service-selector">
    <b-form-select
      v-model="inputVal"
      :options="options"
      :name="name"
      :disabled="readonly || disabled"
      :placeholder="placeholder"
      @change="onChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: undefined
    },
    placeholder: {
      type: String,
      required: true
    },
    visibleData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      inputVal: '',
      options: []
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
    },
    hasError: function(newVal) {
      this.$forceUpdate()
    }
  },
  mounted() {
    this.inputVal = this.value
    if (!this.inputVal) {
      this.inputVal = ''
    }
    this.load()
  },
  methods: {
    load() {
      this.$axios
        .$get('user/manage/list/user', {
          no_loading: true
        })
        .then(response => {
          if (response.resultCode === 'success') {
            for (let i = 0; i < response.data.length; i++) {
              this.options.push({
                value: response.data[i].id,
                text: response.data[i].nm + ' - ' + response.data[i].userId
              })
            }

            this.options.sort(window.sortFunction)
            this.options = [
              { value: '', text: this.$t('common.placeholder.select') }
            ].concat(this.options)
          }
        })
    },
    onChange() {
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
      this.$emit('forceUpdate')
    }
  }
}
</script>
